import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import AboutHorses from '../../HorsesCard/AboutHorses/AboutHorses';
import styles from './HorseStats.module.scss';
import { ReactComponent as FemaleIcon } from '../../../assets/icons/female.svg';
import { ReactComponent as MaleIcon } from '../../../assets/icons/male.svg';
const HorseStats = ({ horse }) => {
    var _a, _b, _c, _d, _e;
    const totalStats = useMemo(() => (horse === null || horse === void 0 ? void 0 : horse.volatile.stats)
        ? Object.values(horse.volatile.stats).reduce((curr, acc) => acc + curr, 0)
        : 0, [horse === null || horse === void 0 ? void 0 : horse.volatile.stats]);
    if (!horse)
        return _jsx(_Fragment, {});
    const parseHorse = {
        totalStats,
        speed: (_a = horse === null || horse === void 0 ? void 0 : horse.volatile.stats) === null || _a === void 0 ? void 0 : _a.speed,
        stamina: (_b = horse === null || horse === void 0 ? void 0 : horse.volatile.stats) === null || _b === void 0 ? void 0 : _b.stamina,
        acceleration: (_c = horse === null || horse === void 0 ? void 0 : horse.volatile.stats) === null || _c === void 0 ? void 0 : _c.acceleration,
        endurance: (_d = horse === null || horse === void 0 ? void 0 : horse.volatile.stats) === null || _d === void 0 ? void 0 : _d.endurance,
        agility: (_e = horse === null || horse === void 0 ? void 0 : horse.volatile.stats) === null || _e === void 0 ? void 0 : _e.agility,
        age: horse === null || horse === void 0 ? void 0 : horse.volatile.age,
        gender: (horse === null || horse === void 0 ? void 0 : horse.static.gender) === 'Male' ? _jsx(MaleIcon, {}) : _jsx(FemaleIcon, {}),
        colour: horse === null || horse === void 0 ? void 0 : horse.static.colour
    };
    return _jsx(AboutHorses, { borderRight: true, className: styles.element, elem: parseHorse });
};
export default HorseStats;
